/**
 * 브라우저 발 API 요청용 W3C Trace Context 생성.
 *
 * 클라이언트 fetch 는 ingress→gateway 로 직행해 Next 서버(OTel)를 거치지 않으므로
 * traceparent 가 없다. 요청마다 trace_id/span_id 를 만들어 헤더로 전파하고 실패
 * 로그에도 같은 값을 실으면, 스팬 수집기 없이도 ELK 에서 클라 에러 ↔
 * ingress/gateway 로그를 trace_id 로 조인할 수 있다.
 *
 * 서버(SSR) fetch 는 @vercel/otel 이 활성 스팬 context 를 이미 전파하므로
 * 브라우저에서만 생성한다.
 */

export interface ClientTraceContext {
  /** `00-{trace_id}-{span_id}-01` */
  traceparent: string;
  trace_id: string;
  span_id: string;
}

function randomHex(byteLength: number): string {
  const bytes = crypto.getRandomValues(new Uint8Array(byteLength));
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function createClientTraceContext(): ClientTraceContext | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }
  const traceId = randomHex(16);
  const spanId = randomHex(8);
  return {
    // trace-flags 01(sampled) — 수집기 도입 시 실제 샘플링 정책은 edge 가 재결정
    traceparent: `00-${traceId}-${spanId}-01`,
    trace_id: traceId,
    span_id: spanId,
  };
}
